const SidebarLikeIconSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25">
        <path
            fill="#16A34A"
            d="M17.5 22h-11V9l7-7 1.25 1.25q.176.175.287.475.113.3.113.575v.35L14.05 9h6.45q.8 0 1.4.6t.6 1.4v2q0 .175-.05.375t-.1.375l-3 7.05q-.225.5-.75.85t-1.1.35m-9-2h9l3-7v-2h-9l1.35-5.5L8.5 9.85zm.037-10.15V20zM6.5 9v2h-3v9h3v2h-5V9z"
        ></path>
    </svg>
);

export default SidebarLikeIconSVG;
